import { LicenseInfo } from '@mui/x-license-pro'

LicenseInfo.setLicenseKey(
  'b5034f50123d4cb76551a3d9955eec4fTz05NjI4OCxFPTE3NTUzNzc2ODMwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLFBWPWluaXRpYWwsS1Y9Mg==',
)

export default LicenseInfo
